/**
 * Base models found in SohoHouse
 *
 * @export
 * @enum {number}
 */
export const enum SohoModel {
  Notification = 'notification',
  NotificationGroup = 'notification_group',
  Perk = 'perk',
  Venue = 'venue',
  Hotel = 'hotel',
  House = 'house',
  Application = 'application',
  ApplicationSubmission = 'application_submissions',
  Sitecore = 'sitecore',
  InquiryType = 'inquiry_type',
  Inquiry = 'inquiry',
  Product = 'product',
  Attachment = 'attachment',
  Availability = 'availability',
  AvailabilityRate = 'availability_rate',
  RatePlan = 'rate_plan',
  Room = 'room',
  Promotion = 'promotion',
  Booking = 'room_booking',
  Invite = 'invite',
  GuestList = 'guest_list',
  Card = 'card',
  Redemption = 'redemption'
}

/**
 * API specific url
 * ? Prefixed with the service name
 */
export const SohoApiModel: { [model: string]: string } = {
  [SohoModel.Notification]: 'communications/notifications',
  [SohoModel.NotificationGroup]: 'communications/notification_groups',
  [SohoModel.Perk]: 'content/perks',
  [SohoModel.Venue]: 'venues/venues',
  [SohoModel.Application]: 'applications/applications',
  [SohoModel.ApplicationSubmission]: 'applications/application_submissions',
  [SohoModel.Sitecore]: 'sitecore/sitecore',
  [SohoModel.InquiryType]: 'support/v2/inquiry_types',
  [SohoModel.Inquiry]: 'support/v2/inquiries',
  [SohoModel.Product]: 'applications/products',
  [SohoModel.Attachment]: 'applications/attachments',
  [SohoModel.Availability]: 'rooms/availabilities',
  [SohoModel.Promotion]: 'rooms/promotions',
  [SohoModel.Booking]: 'rooms/room_bookings',
  [SohoModel.Invite]: 'guests/invites',
  [SohoModel.GuestList]: 'guests/guest_lists',
  [SohoModel.Redemption]: 'applications/redemptions'
}
